module.exports = require("core-js/modules/esnext.set.delete-all.js");